import { render, staticRenderFns } from "./Manage_news.vue?vue&type=template&id=2a5c5ffa&scoped=true&"
import script from "./Manage_news.vue?vue&type=script&lang=js&"
export * from "./Manage_news.vue?vue&type=script&lang=js&"
import style0 from "./Manage_news.vue?vue&type=style&index=0&id=2a5c5ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5c5ffa",
  null
  
)

export default component.exports